import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../../server";
import { Button, Input, message, Popconfirm, Select, Table } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { hasSubstring } from "../../../extensions/helper";
import { RefreshButton } from "../../../extensions/design";
import { useSelector } from "react-redux";
import TagModal from "./tag";
import { TAG_OBJECT_VID_CLIENTS, tagObjectVidLabels, tagObjectVidOptions } from "./tags-const";

const Tags = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [objectVid, setObjectVid] = useState(TAG_OBJECT_VID_CLIENTS);
  const [filter, setFilter] = useState({ searchText: "" });
  const divRef = useRef(null);
  const user = useSelector((s) => s.user);

  const getData = () => {
    if (!user?.companyId) return;
    setLoading(true);
    const objectVids =
      objectVid != null ? [objectVid] : tagObjectVidOptions.map((option) => option.value);
    serverFetch("Tag", { queryParams: { objectVid: objectVids } })
      .then((data) => {
        setItems(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getData, [user?.companyId, objectVid]);

  const columns = [
    { title: "#", dataIndex: "id", width: 72 },
    ...(objectVid == null
      ? [
          {
            title: "Тип",
            dataIndex: "objectVid",
            width: 120,
            render: (value) => tagObjectVidLabels[value] ?? value,
          },
        ]
      : []),
    {
      title: "Цвет",
      dataIndex: "color",
      width: 100,
      render: (color) => (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            aria-hidden
            style={{
              width: 22,
              height: 22,
              borderRadius: 4,
              background: color?.startsWith?.("#") ? color : `#${color ?? "ccc"}`,
              border: "1px solid rgba(0,0,0,0.08)",
            }}
          />
        </span>
      ),
    },
    { title: "Название", dataIndex: "value" },
    {
      title: "",
      key: "delete",
      width: 48,
      align: "center",
      render: (_, record) => (
        <Popconfirm
          title="Удалить тег?"
          description="Если тег используется, удаление будет запрещено."
          onConfirm={(e) => handleDelete(record, e)}
          onCancel={(e) => e?.stopPropagation()}
          okText="Да"
          cancelText="Нет"
        >
          <Button type="text" size="small" danger icon={<DeleteOutlined />} onClick={(e) => e.stopPropagation()} />
        </Popconfirm>
      ),
    },
  ];

  const onClose = (refresh) => {
    setEditId(undefined);
    if (refresh) getData();
  };

  const handleDelete = (record, e) => {
    e?.stopPropagation();
    setLoading(true);
    serverFetch("Tag", { method: "DELETE", queryParams: { id: record.id } })
      .then(() => getData())
      .catch((err) => {
        setLoading(false);
        message.error(err.userMessage);
      });
  };

  const headerSize = divRef.current?.querySelector(".ant-table-thead")?.offsetHeight ?? 0;
  const tableHeight = divRef.current
    ? document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY - 1
    : 0;
  const tableWidth = document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left || 0;

  const filtered = items.filter((item) => hasSubstring(filter.searchText, item.value));

  return (
    <div>
      <div className="sport-form-title">
        <span style={{ marginRight: 8 }}>Тип тегов</span>
        <Select
          value={objectVid}
          onChange={(value) => {
            setObjectVid(value ?? null);
            setEditId(undefined);
          }}
          options={tagObjectVidOptions}
          allowClear
          placeholder="Все типы"
          style={{ width: 200 }}
        />
        <Input
          placeholder="Поиск"
          value={filter.searchText}
          onChange={(e) => setFilter((prev) => ({ ...prev, searchText: e.target.value }))}
          style={{ maxWidth: 200 }}
          allowClear
        />
        <Button type="primary" onClick={() => setEditId(0)} disabled={objectVid == null}>
          Новый
        </Button>
        <RefreshButton onClick={getData} />
      </div>
      <div ref={divRef} style={{ width: tableWidth }}>
        <Table
          dataSource={filtered}
          columns={columns}
          rowKey="id"
          loading={loading}
          size="small"
          pagination={false}
          scroll={{ y: tableHeight }}
          rowSelection={{
            type: "radio",
            selectedRowKeys: editId != null && editId !== 0 ? [editId] : [],
            renderCell: (checked) => <div className={checked ? "list-indicator" : ""} />,
          }}
          onRow={(record) => ({ onClick: () => setEditId(record.id) })}
        />
      </div>
      {editId != null && (
        <TagModal
          id={editId === 0 ? null : editId}
          objectVid={objectVid}
          companyId={user?.companyId}
          onClose={onClose}
        />
      )}
    </div>
  );
};

export default Tags;
